import { StateProvider } from "@uirouter/angularjs";
import {
  ProjectsViewController,
  HtmlTemplate as ProjectViewHtmlTemplate,
} from "./views/Projects";

export function routeConfig($stateProvider: StateProvider) {
  $stateProvider
    .state("main.projects", {
      url: "projects",
      template: "<ui-view></ui-view>",
      abstract: true,
    })
    .state("main.projects.grid", {
      url: "",
      controller: ProjectsViewController,
      controllerAs: "stateController",
      template: ProjectViewHtmlTemplate,
    });
}
routeConfig.$inject = ["$stateProvider"];
